import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_3pi3q87y4r: FaireBrandEntity = {
  token: "b_3pi3q87y4r",
  type: "brand",
  name: "Sugarox Candy Studio LLC",
  avatarUrl:
    "https://cdn.faire.com/fastly/c6d2dcc0459f424417b5475c9137f9ef4012ab8753c7e096a798ec809ca3c5de.png",
  bannerUrl:
    "https://cdn.faire.com/fastly/08db12b4720fc0e1e0937b03f6152c4615a44f01afa93033c52454a217afeaaa.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/c6d2dcc0459f424417b5475c9137f9ef4012ab8753c7e096a798ec809ca3c5de.png",
  heroImageUrl:
    "https://cdn.faire.com/fastly/08db12b4720fc0e1e0937b03f6152c4615a44f01afa93033c52454a217afeaaa.jpeg",
  location: "Austin, TX, USA",
  minimumOrderDollars: 81,
  rating: 5,
  reviewCount: 118,
  isTopShop: true,
  isInsider: true,
  description:
    "Tamalitoz by Sugarox is the creation of husband & husband team (Jack & Dec).  We started our journey opening up a Candy Studio producing small batch runs of hard candy at our first store in Mexico City.  We combined traditional European candy making (that would come from Dec's side being as he is from the UK) with the sweet flavors of Mexico (thats where Jack is from).\nWe developed a product line called Tamalitoz by Sugarox, a naturally flavored hard candy pillow filled with a mild blend of chili lime and sea salt.  \nUnlike most Mexican style candy that is covered in chili,  it is has the chili on the inside.  By doing so, you first get the sweet and tangy fruit flavor of the candy, and as you eat it,  you get hints of the chili lime, until you reach the center when you get a burst of flavor.\nTamalitoz comes if 5 amazing flavors,  Divine Watermelon, Lip Smacking Mango, Pineapple Galore, Cucumber Extravaganza and Tantalizing Tamarind.",
  meta: {
    source: "api",
    importedAt: "2026-03-26T23:51:37.401Z",
    importedBy: "entity-db-cli",
  },
};
